export default "__VITE_ASSET__Di3go26Q__"